import { id } from "date-fns/locale";
import React, { useState } from "react";

const faqs = [
    {
        id: 1,
        question: "What is a Certified Financial Advisor?",
        answer:
            "A Certified Financial Advisor (CFA) is a financial professional who has achieved the highest level of expertise and credentialing in the field. CFAs are rigorously trained and have passed a series of exams administered by the CFA Institute, covering areas such as investment management, ethics, and economics. They are trusted experts in finance who provide clients with comprehensive financial planning, investment advice, and strategies to achieve their financial goals. The CFA designation signifies a commitment to excellence, ethics, and a deep understanding of the intricacies of financial markets, making CFA invaluable guides for individuals and organizations seeking financial success."
    },
    {
        id: 2,
        question: "What is the Role of a Financial Advisor?",
        answer:
            "The role of a financial advisor is to guide clients in managing their finances effectively. This includes creating personalized financial plans, managing investments, planning for retirement, optimizing tax strategies, and ensuring adequate risk management through insurance. Advisors also provide education, monitor progress, and adapt strategies to meet changing goals and circumstances, ensuring clients achieve financial stability and long-term success."
    },
    {
        id: 3,
        question: "What Exactly Does a Financial Advisor Do?",
        answer:
            "A financial advisor helps clients decide how to manage their money. They assess their client’s economic health and determine their long- and short-term goals before making recommendations to meet them. Financial advisors help invest their clients’ money in the stock market and other investments, recommend products like life insurance, or offer assistance with tax planning. Financial advisors may also educate their clients about their financial health and habits that can help them build their wealth. In addition to working directly with clients, financial advisors spend time marketing their services. Many financial advisors may spend considerable time establishing and building client relationships."
    },
    {
        id: 4,
        question: "Which is Better, CFA or CFP?",
        answer:
            `A CFA is a financial professional who has passed a series of exams administered by the CFA Institute. They are often employed by investment management companies and analyze companies' growth, profitability, and creditworthiness. CFAs also provide personal financial planning and wealth management services.

A CFP is a financial advisor who typically works with individual clients. They are known for their trustworthiness and follow a strict code of ethics. CFPs offer a range of financial management services, such as retirement planning, tax planning, and risk management.`
    },
    {
        id: 5,
        question: "How to Become a SEBI Certified Financial Advisor?",
        answer:
            "To become a SEBI-certified financial advisor, meet the eligibility criteria, which include a postgraduate degree in finance-related fields, CFA, or NISM certifications, and 2-5 years of relevant experience. Ensure a minimum net worth of ₹5 lakhs (individuals) or ₹50 lakhs (non-individuals). Set up adequate infrastructure, including office space and research tools. Obtain BASL approval and then apply to SEBI with the required documents and a non-refundable ₹2000 application fee. Once approved, adhere to SEBI guidelines for compliance and certification renewal."
    },
    {
        id: 6,
        question: "Is it Good to Be a Financial Advisor?",
        answer:
            "Becoming a financial advisor can be a rewarding career if you enjoy assisting people with their financial goals, have a knack for understanding complex financial concepts, and are dedicated to building strong client relationships. However, the profession is highly competitive, demands continuous learning to keep up with regulations, and can be stressful, making it a better fit for those who thrive under pressure and have a passion for personal finance."
    },
    {
        id: 7,
        question: "How Do Financial Consultants Earn?",
        answer: "Financial consultants earn through a combination of client fees, commissions, and salaries. Client fees can be charged hourly, as a fixed amount, or as a percentage of assets under management. Commissions come from transactions like selling insurance products or trading securities. Additionally, some consultants working for firms receive traditional salaries. The exact payment structure varies by firm, as there is no universal approach to how financial consultants are compensated."
    },
    {
        id: 8,
        question: "What is a Personal Financial Planner?",
        answer: "A personal financial planner is someone who helps you manage your money and reach your long-term goals, like saving for retirement or funding your kids' education. They advise on investments, taxes, and budgeting, and may specialize in areas like retirement planning or estate planning. Some planners work with specific groups, such as young professionals or retirees, to tailor their advice to your needs.",
    },
   
     {

        id: 9,
        question: "How Much Does a Certified Financial Planner Cost in India?",
        answer:
            "The cost of becoming a Certified Financial Planner (CFP) in India typically ranges from INR 1.5 to 2 lakhs. Annual charges for CFP services can vary between INR 6,000 and INR 40,000, depending on the advisor. These professionals assist with investment planning, risk management, asset management, and tax planning."
    },
    {
        id: 10,
        question: "What is a Virtual Financial Advisor??",
        answer:
            "A virtual financial advisor is an expert who offers personalized financial guidance remotely, leveraging digital tools and technology. They provide live advice on planning and investing, using communication methods such as videoconferencing and co-browsing. These advisors often utilize digital platforms to streamline the advisory process."
    },
    {
        id: 11,
        question: "What Does a Digital Financial Planner Do?",
        answer:
            "A digital financial planner is perfect for staying organized and taking control of your money. It helps you track expenses, set budgets, plan for future goals, and make smarter investment decisions, all through convenient online tools. With real-time insights and personalized advice, it empowers you to make informed financial decisions and stay on top of your financial journey",
    },
    {
        id: 12,
        question: "Is There an AI Financial Advisor?",
        answer:
            "Yes, there are AI financial advisors, commonly known as robo-advisors, that use artificial intelligence (AI) to provide financial advice. These automated platforms analyze your financial data and goals, offering personalized investment strategies, portfolio management, and financial planning advice.",
    },
   
    {
        id: 14,
        question: "Who Needs Financial Planning?",
        answer:
            "Financial planning is beneficial for everyone a must regardless of age or financial situation. Major life events like graduating college, getting married, expanding your family, or starting a business often prompt the need to reassess finances. A financial advisor can guide you through these changes, helping you stay on track with your goals.",
    },
    {
        id: 15,
        question: "What Does a Digital Financial Planner Do?",
        answer:
            "To become a financial planner, you typically need a bachelor's degree in a relevant field, such as finance, business, accounting, economics, or law, from an accredited institution. Additionally, obtaining a certification like the Certified Financial Planner (CFP) from FPSB India, which is globally recognized, is essential. You must also pass a financial planning exam to meet professional standards. Key skills that benefit financial planners include strong analytical and research abilities, attention to detail, and mathematical proficiency, which are crucial for developing effective financial strategies and staying updated on trends."
    }
];

const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section id="faq" className="tw-py-20 tw-bg-gray-50">
            <div className="tw-container tw-mx-auto tw-px-6">
                <div className="tw-text-center tw-mb-16">
                    <h2 className="tw-text-4xl tw-font-bold tw-text-gray-800 tw-mb-4">
                        Frequently Asked Questions
                    </h2>
                    <p className="tw-text-lg tw-text-gray-600 tw-max-w-2xl tw-mx-auto">
                        Get answers to the most common questions about financial planning and our advisory services.
                    </p>
                </div>

                <div className="tw-max-w-4xl tw-mx-auto">
                    <div className="tw-space-y-4">
                        {faqs.map((faq, index) => (
                            <div key={faq.id} className="tw-neumorphic tw-rounded-xl tw-overflow-hidden">
                                <button
                                    className="tw-w-full tw-text-left tw-p-6 focus:tw-outline-none"
                                    onClick={() => toggleFAQ(index)}
                                >
                                    <div className="tw-flex tw-justify-between tw-items-center">
                                        <h3 className="tw-text-lg tw-font-semibold tw-text-gray-800 tw-pb-0">
                                            {faq.question}
                                        </h3>
                                        <i
                                            className={`fas fa-chevron-down tw-text-gray-600 tw-transition-transform tw-duration-300 ${activeIndex === index ? "tw-rotate-180" : ""
                                                }`}
                                        ></i>
                                    </div>
                                </button>
                                <div
                                    className={`tw-px-6 tw-py-6 tw-bg-gray-100 tw-text-gray-600 tw-transition-all tw-duration-300 ${activeIndex === index ? "tw-block" : "tw-hidden"
                                        }`}
                                >
                                    {faq.answer}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
